<template>
  <div :style="`height:${dispH}px;width:${dispW}px;position: relative`">
    <el-container>
      <el-aside v-if="isColorBarVisible" :width="`${colorBarWidth}px;`">
        <ColorBar
          :dispW="colorBarWidth"
          :dispH="colorBarHeight > 0 ? colorBarHeight : dispH - 30"
          :parentForm="parentForm"
          :indexInForm="indexInForm"
        ></ColorBar>
      </el-aside>
      <el-container>
        <el-header
          v-if="!isRGP"
          :height="titleHeight"
          :style="`width:${isColorBarVisible ? dispW - colorBarWidth : dispW}px;padding:0px;`"
        >
          <el-select
            placeholder=""
            v-if="isSelectVisibleBoolen"
            v-model="mapIndexUI"
            @change="selectMapStyle"
          >
            <el-option
              v-for="(item, index) in normalMapStyles"
              :key="item"
              :label="mapTypeShown[index]"
              :value="mapStyles[item]"
            ></el-option>
          </el-select>
          <p class="const-title" v-if="!isSelectVisibleBoolen && isTilteVisible && forcedTitle">
            {{ forcedTitle }}
          </p>
          <p class="const-title" v-else-if="!isSelectVisibleBoolen && isTilteVisible">
            {{ mapTypeShown[getMapIndex] }}
          </p>
        </el-header>
        <el-main>
          <Map
            :mapIndexUI="mapIndexUI"
            :indexInForm="indexInForm"
            :parentForm="parentForm"
            :dispW="dispW - (isColorBarVisible ? colorBarWidth : 0)"
            :dispH="dispH - (isSelectVisibleBoolen ? 70 : 20)"
            :isRGP="isRGP"
            :isDiff="isDiff"
            :mapValues="mapValues"
            :isZernike="isZernike"
            :rgpDia="rgpDia"
          ></Map>
        </el-main>
        <!-- <div
          v-if="isRGP"
          class="rgb-buttons"
          :style="`left:${colorBarWidth + 15}px;top:${
            dispH - 300 - 30
          }px;height:300px;`"
        >
          <RGPButtons />
        </div>-->
        <div v-if="isRGP" class="rgb-buttons" :style="`right:30px;top:${30}px;height:300px;`">
          <RGPButtons />
        </div>
      </el-container>
    </el-container>
    <RgpPosVue
      :show="isRgpSettingsVisible"
      @close="isRgpSettingsVisible = false"
      @save="saveRgpSettings"
      :rgpPos="rgpPos"
    ></RgpPosVue>
    <div
      v-if="isRGP"
      class="rgp-pos"
      :style="`left:${colorBarWidth + 5}px`"
      @click="shoRgpSettings"
    >
      <div class="rgp-params">
        {{ $t("langcfg.txtOffset") }} X: {{ rgpPosSettings.offsetX._toFixed(2) }}mm
      </div>
      <div class="rgp-params">
        {{ $t("langcfg.txtOffset") }} Y: {{ rgpPosSettings.offsetY._toFixed(2) }}mm
      </div>
      <div class="rgp-params">
        {{ $t("langcfg.txtOffset") }} Z: {{ rgpPosSettings.offsetZ._toFixed(2) }}μm
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import Map from "./Map.vue";
import ColorBar from "./ColorBar.vue";
import RGPButtons from "./RGP-Buttons";
import { Size, SubPageSize } from "../../mixins";
import RgpPosVue from "../pages/dialog-forms/RgpPos.vue";
import { NORMALMAPSTYLES, MAPSTYLES } from "../shared/index";
import { TOPOGRAPHYEVENTS } from "../shared/events";
import { isDefined, objectCopy } from "../../shared/utils";
export default {
  name: "MapForm",
  data() {
    return {
      normalMapStyles: NORMALMAPSTYLES,
      mapStyles: MAPSTYLES,
      mapIndexUI: MAPSTYLES[NORMALMAPSTYLES[0]], // 对应算法中的地形图索引
      elevParams: global.elevParams,
      isRgpSettingsVisible: false,
      rgpPosSettings: window.rgpPosSettings
    };
  },
  mounted() {
    let index = this.mapDrawSettings[this.parentForm][`mapInForm${this.indexInForm}`]["mapIndexUI"];
    this.mapIndexUI = index;
    if (this.isDiff) {
      if (
        this.record &&
        this.record.contrasts &&
        isDefined(this.record.contrasts[0]) &&
        isDefined(this.record.contrasts[1])
      )
        this.mapIndexUI = this.record.contrasts[2];
      this.$emit("changeMapType", this.mapIndexUI);
    }
    this.$emit("hide-waiting");
  },
  destroyed() {
    this.$destroy();
  },
  watch: {
    rgpPos: {
      handler: function (val) {
        this.rgpPosSettings = objectCopy(val);
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    shoRgpSettings() {
      this.isRgpSettingsVisible = true;
    },
    saveRgpSettings: function (settings) {
      this.rgpPosSettings = objectCopy(settings);
      this.$bus.$emit(TOPOGRAPHYEVENTS.rgpOffsetChanged, settings);
      this.isRgpSettingsVisible = false;
    },
    selectMapStyle: function () {
      this.mapDrawSettings[this.parentForm][`mapInForm${this.indexInForm}`]["mapIndexUI"] =
        this.mapIndexUI;
      if (this.isDiff) {
        this.$emit("changeMapType", this.mapIndexUI);
      }
    },
    rShown() {
      let lbl = this.elevParams.isInitial
        ? `BF${this.elevParams.sphereElli === 0 ? "S" : "E"}`
        : "r";
      let rs = this.elevParams.values.rs._toFixed(2);
      let floatLbl = this.elevParams.isFloat ? " Float" : "";
      return `${lbl}=${rs}${floatLbl}`;
    },
    diaShown() {
      return `Dia=${this.elevParams.values.dia._toFixed(2)}`;
    }
  },
  computed: {
    ...mapGetters(["mapDrawSettings"]),
    mapTypeShown: function () {
      let lbls = [];
      NORMALMAPSTYLES.map((ms) => {
        lbls.push(this.$t(`langcfg.txt${ms}`));
      });

      if (this.isDiff) return lbls;
      lbls[2] = `${lbls[2]} ${this.rShown()},${this.diaShown()}`;
      return lbls;
    },
    getMapIndex() {
      return NORMALMAPSTYLES.indexOf(MAPSTYLES[this.mapIndexUI]);
    },
    titleHeight() {
      if (this.isSelectVisibleBoolen) {
        return "50px";
      } else if (this.isTilteVisible) {
        return "30px";
      } else {
        return "10px";
      }
    }
  },
  mixins: [Size, SubPageSize],
  components: {
    Map,
    ColorBar,
    RGPButtons,
    RgpPosVue
  },
  props: {
    rgpDia: {
      type: Number,
      default: 6
    },
    rgpPos: {
      type: Object,
      default: () => {
        return {
          offsetX: 0,
          offsetY: 0,
          offsetZ: 5
        };
      }
    },
    dispW: {
      type: Number,
      default: window.screen.width - 30 - 500
    },
    dispH: {
      type: Number,
      default: window.screen.height - 80 - 10
    },
    colorBarWidth: {
      type: Number,
      default: 120
    },
    colorBarHeight: {
      type: Number,
      default: 0
    },
    isSelectVisibleBoolen: {
      type: Boolean,
      default: true
    },
    constMapIndex: {
      type: Number,
      default: -1
    },
    parentForm: {
      type: String,
      default: ""
    },
    indexInForm: {
      type: Number,
      default: 0
    },
    url: String,
    isRGP: {
      type: Boolean,
      default: false
    },
    isColorBarVisible: {
      type: Boolean,
      default: true
    },
    isDiff: {
      type: Boolean,
      default: false
    },
    mapValues: {
      type: Object,
      default: () => {
        return {};
      }
    },
    isTilteVisible: {
      type: Boolean,
      default: true
    },
    isZernike: {
      type: Boolean,
      default: false
    },
    value: Boolean,
    forcedTitle: {
      type: String,
      default: ""
    },
    record: {
      type: Object
    }
  }
};
</script>
<style scoped lang="less">
p {
  margin: 0px;
  padding: 0px;
  width: 100%;
}

// /deep/ .el-select .el-select__caret {
//   color: #fff;
// }
/deep/ .el-select .el-select-dropdown__wrap {
  max-height: 350px;
}
.el-container {
  /* border: 1px solid gray; */
  border-top: none;
  border-left: none;
}
.rgb-buttons {
  position: absolute;
}
.const-title {
  font-size: 20px;
  box-sizing: border-box;
  height: 30px;
  line-height: 30px;
  border: 1px solid gray;
}
.el-select {
  width: 100%;
}
.el-select /deep/ input {
  font-size: 30px;
  background-color: #44444c;
  color: #fff;
  border-radius: 0px;
}
.el-select /deep/ .el-input__inner {
  font-size: 30px;
  height: 50px;
  background-color: #44444c;
  color: #fff;
  border-radius: 0px;
}
li.el-select-dropdown__item {
  font-size: 40px;
  height: 50px;
  background-color: #44444c;
  color: #fff;
}
.el-select-dropdown__item /deep/ span {
  font-size: 25px;
  height: 50px;
  background-color: #44444c;
  color: #fff;
}
.rgp-pos {
  position: absolute;
  top: 0px;
  min-width: 120px;
  height: 120px;
  border: 1px solid gray;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
}
.rgp-params {
  width: 100%;
  text-align: left;
  padding: 5px;
}
</style>



// WEBPACK FOOTER //
// src/topography/components/MapForm.vue